import {JwtAxios} from "@/packaging";
import dayjs from "dayjs";

export const officeAPI = {
    async GetOffice(page,limit=15,startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Office/GetOffice?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },
    async GetOfficeCount(startDate="",endDate="", keywordType="",keyword=""){
        if(startDate=="" || endDate =="") {
            startDate='1990-01-01'
            endDate= dayjs().format('YYYY-MM-DD')
        }
        const responseModel = await JwtAxios.get(`/Office/GetOfficeCount?startDate=${startDate}&endDate=${endDate}&keywordType=${keywordType}&keyword=${keyword}`);
        return responseModel
    },

    async GetOfficeTotalCount(){
        const responseModel = await JwtAxios.get(`/Office/GetOfficeTotalCount`);
        return responseModel
    },

    async ExportExcel(model){
        const responseModel = await JwtAxios.download(`/Office/ExportExcel`,model);
        return responseModel
    },
}